import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/flat-rates/$packageId",
)({
  beforeLoad: ({ params: { packageId } }) => {
    throw redirect({
      to: "/templates/quotes/$packageId",
      params: { packageId },
      replace: true,
    })
  },
})
